import ParameterTypeModel from '../models/ParameterTypeModel';
import BaseStore from './BaseStore';
import { computed, action, toJS } from 'mobx';

export default class ParameterTypeStore extends BaseStore {
  parameterStore;
  constructor(transportLayer, parameterStore) {
    super(ParameterTypeModel, transportLayer);
    this.parameterStore = parameterStore;
  }

  flattenTableData(dataArray) {
    const arr = [];

    dataArray.forEach(parameterType => {
      arr.push({
        type: 'PARAMETER_TYPE',
        level: 1,
        key: parameterType.id,
        slug: 'parameter-type',
        childSlug: `parameter-type/${parameterType.id}/parameter`,

        id: parameterType.id,
        name: parameterType.name,
        code: null,
        description: null,
        unit: parameterType.unit_name,

        data: {
          id: parameterType.id,
          name: parameterType.name,
          unit_id: parameterType.unit_id,
          unit_name: parameterType.unit_name,
          unit_symbol: parameterType.unit_symbol,
        },
      });

      parameterType &&
        parameterType.parameters &&
        parameterType.parameters.forEach(parameter => {
          arr.push({
            type: 'PARAMETER',
            level: 2,
            key: `${parameterType.id}.${parameter.id}`,
            slug: `parameter-type/${parameterType.id}/parameter`,

            id: parameter.id,
            name: parameter.name,
            code: parameter.code,
            description: parameter.description,
            unit: null,
            parent_id: parameterType.id,

            data: {
              id: parameter.id,
              code: parameter.code,
              name: parameter.name,
              description: parameter.description,
            },
          });
        });
    });

    return arr;
  }

  @computed get tableData() {
    return this.flattenTableData(this.items);
  }

  @action updateParameter(parameter, parameterTypeId) {
    let parameterType = this.items.find(item => item.id == parameterTypeId);
    let parameterIndex = !!parameterType && !!parameterType.parameters ? parameterType.parameters.indexOf(parameterType.parameters.filter(param => param.id == parameter.id)[0]) : -1;
    if (parameterIndex > -1) {
      this.items.find(item => item.id == parameterTypeId).parameters[parameterIndex] = parameter;
    } else {
      if (!!parameterType && !parameterType.parameters)
        this.items.find(item => item.id == parameterTypeId).parameters = [];
      this.items.find(item => item.id == parameterTypeId).parameters.push(parameter);
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/ParameterTypeStore.js